export default "<p>shared-transaction works!</p>\n"